import _asyncToGenerator from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.regexp.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import Construction from 'src/store/models/Construction';
import Issue from 'src/store/models/Issue';
import Contact from 'src/store/models/Contact';
import Typology from 'src/components/Typology';
import Cookies from 'quasar/src/plugins/Cookies.js';import QCarousel from 'quasar/src/components/carousel/QCarousel.js';import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';import QCarouselControl from 'quasar/src/components/carousel/QCarouselControl.js';import QImg from 'quasar/src/components/img/QImg.js';import QSpinner from 'quasar/src/components/spinner/QSpinner.js';;
import { ShareNetwork } from 'vue-social-sharing';
import VueRecaptcha from 'vue-recaptcha';
import RequestInfoDialog from 'src/components/RequestInfoDialog';
export default {
  name: 'Construction',
  meta: function meta() {
    var construction = Construction.query().with('city').with('typologies.typology_category').with('images', function (query) {
      query.orderBy('order_number');
    }).where('web_code', this.$route.params.webCode).first();
    if (!construction) {
      return {
        meta: {}
      };
    }
    var firstImageUrl = construction.images.length ? construction.images[0].image_res.regular : process.env.SOCIAL_BASE_URL + '/statics/images/logo_horiz.svg';
    var categories = [];
    var minArea,
      maxArea = 0;
    construction.typologies.forEach(function (t) {
      if (t.typology_category && !categories.includes(t.typology_category.name)) {
        categories.push(t.typology_category.name);
      }
      if (!minArea || minArea > t.area) {
        minArea = t.area;
      }
      if (!maxArea || maxArea < t.area) {
        maxArea = t.area;
      }
    });
    var description = "Case di nuova costruzione in vendita direttamente dal costruttore nel cantiere di ".concat(construction.name).concat(construction.city ? ', ' + construction.city.name : '', ". Tipologie Immobili: ").concat(categories.join(', ')).concat(minArea && maxArea ? ' - Tagli da mq ' + minArea + ' a mq ' + maxArea : '');
    return {
      // sets document title
      title: "Nuova costruzione - ".concat(construction.city ? construction.city.name : '', ", ").concat(construction.name, " [").concat(construction.web_code, "]").concat(construction.owner_contact ? ' da ' + construction.owner_contact.name : ''),
      // meta tags
      meta: {
        description: {
          name: 'description',
          content: description
        },
        ogtitle: {
          property: 'og:title',
          content: "[".concat(construction.web_code, "] ").concat(construction.name, ", ").concat(construction.city.name, " su Trovacantieri.it")
        },
        ogdescription: {
          property: 'og:description',
          content: description
        },
        ogimage: {
          property: 'og:image',
          content: firstImageUrl
        },
        ogimagesecure: {
          property: 'og:image:secure_url',
          content: firstImageUrl
        },
        twittercard: {
          property: 'twitter:card',
          content: 'summary'
        },
        twittersite: {
          property: 'twitter:site',
          content: '@trovacantieri'
        },
        twittertitle: {
          property: 'twitter:title',
          content: "[".concat(construction.web_code, "] ").concat(construction.name, ", ").concat(construction.city.name, " su Trovacantieri.it")
        },
        twitterdescription: {
          property: 'twitter:description',
          content: description
        },
        twitterimage: {
          property: 'twitter:image',
          content: firstImageUrl
        },
        keywords: {
          name: 'keywords',
          content: "cantiere vendita case immobili ".concat(construction.name, " ").concat(construction.city.name, " ").concat(construction.web_code)
        },
        equiv: {
          'http-equiv': 'Content-Type',
          content: 'text/html; charset=UTF-8'
        }
      }
    };
  },
  components: {
    QCarousel: QCarousel,
    QCarouselSlide: QCarouselSlide,
    QCarouselControl: QCarouselControl,
    QSpinner: QSpinner,
    Typology: Typology,
    ShareNetwork: ShareNetwork,
    VueRecaptcha: VueRecaptcha,
    QImg: QImg,
    RequestInfoDialog: RequestInfoDialog
  },
  watch: {
    // call again the method if the route changes
    '$route': function $route(val) {
      this.code = val.params.webCode;
      this.fetchData();
    }
  },
  data: function data() {
    return {
      apiKey: process.env.GOOGLE_API_KEY || 'AIzaSyAt-5tQM_uYRx7Q1cFGOMbtNx2fq7sdZz8',
      recaptchaKey: process.env.RECAPTCHA_SITE_KEY,
      code: null,
      preview: false,
      slide: 1,
      typologyStyle: 'grid',
      fullscreen: false,
      showIssueDialog: false,
      showUpdateMeDialog: false,
      showRequestInfoDialog: false,
      showContactsListDialog: false,
      selectedContactId: null,
      updateEmail: '',
      agreeToTerms: false,
      recaptchaCode: '',
      issueEmail: '',
      issueText: '',
      loading: true,
      contactEmail: null,
      contactType: null,
      foundConstructionsCount: 0,
      currentUrl: process.env.SOCIAL_BASE_URL + this.$router.currentRoute.fullPath
    };
  },
  computed: {
    constructionIsArchived: {
      get: function get() {
        return this.construction.status === 'archived';
      },
      set: function set(isArchived) {
        return isArchived;
      }
    },
    lastResultsRoute: function lastResultsRoute() {
      return this.$store.state.app.lastResultsRoute || "/".concat(this.construction.city.state.slug, "/").concat(this.construction.city.slug);
    },
    construction: function construction() {
      return Construction.query().withAllRecursive().with('company').with('typologies', function (q) {
        q.orderBy('sold').orderBy('order_number');
      }).with('images', function (query) {
        query.orderBy('order_number');
      }).with('typologies.images', function (query) {
        query.orderBy('order_number');
      }).where('web_code', this.code).first();
    },
    sales_companies: function sales_companies() {
      return this.construction ? this.construction.contacts.filter(function (contact) {
        return contact.pivot.sales_company;
      }) : [];
    },
    sales_agencies: function sales_agencies() {
      return this.construction ? this.construction.contacts.filter(function (contact) {
        return contact.pivot.sales_agency;
      }) : [];
    },
    other_sales_agencies: function other_sales_agencies() {
      return this.construction ? this.construction.contacts.filter(function (contact) {
        return contact.pivot.other_sales_agency;
      }) : [];
    },
    personalContact: function personalContact() {
      return this.construction ? Contact.query().where('company_id', this.construction.company_id).where('personal_contact', true).first() : null;
    },
    dataOld: function dataOld() {
      return this.construction.imported_data ? this.construction.imported_data : {};
    },
    phoneContacts: function phoneContacts() {
      if (this.sales_agencies.length > 0) {
        return this.sales_agencies;
      } else if (this.sales_companies.length > 0) {
        return this.sales_companies;
      } else {
        var contact = Contact.query().where('company_id', this.construction.company_id).where('personal_contact', true).first();
        return contact ? [contact] : [];
      }
    },
    plainTextConstructionDescription: function plainTextConstructionDescription() {
      // also replace html special characters such as &nbsp; &gte; &lt; &amp; etc.
      var desc = this.construction.description ? this.construction.description.replace(/&[^;]+;/g, '') : null;
      // replace also \n, \r, \t with spaces
      desc = desc ? desc.replace(/[\n\r\t]/g, ' ') : null;
      return desc ? desc.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, '') : '';
    },
    firstImageUrl: function firstImageUrl() {
      // If not present, return the app logo
      return this.construction.images.length ? this.construction.images[0].image_res.regular : process.env.SOCIAL_BASE_URL + '/statics/images/logo_horiz.svg';
    }
  },
  methods: {
    goToSearch: function goToSearch() {
      return this.$router.push('/' + this.construction.city.state_slug);
    },
    backToResults: function backToResults() {
      // Workaround for mobile browsers that don't allow a simple window.close()
      var win = window.open('', '_self');
      win.close();
    },
    showPrivacyDialog: function showPrivacyDialog() {
      window.open('/statics/legal/informativa_privacy.html', '_blank');
    },
    scrollToPhone: function scrollToPhone() {
      var _this = this;
      if (this.sales_companies.length === 1 && this.sales_agencies.length === 0) {
        var salesCompany = this.sales_companies[0];
        if (salesCompany.phone) {
          // Show call confirmation dialog
          this.$q.dialog({
            title: 'Chiama',
            message: "Vuoi chiamare la societ\xE0 ".concat(salesCompany.name, "?"),
            cancel: {
              label: 'Annulla',
              color: 'negative'
            },
            ok: {
              label: 'Chiama',
              color: 'primary'
            },
            persistent: true
          }).onOk(function () {
            window.open("tel:".concat(_this.parsePhoneNumber(salesCompany.phone)));
          });
        }
      } else if (this.sales_companies.length === 0 && this.sales_agencies.length === 1) {
        var salesAgency = this.sales_agencies[0];
        if (salesAgency.phone) {
          // Show call confirmation dialog
          this.$q.dialog({
            title: 'Chiama',
            message: "Vuoi chiamare la societ\xE0 ".concat(salesAgency.name, "?"),
            cancel: {
              label: 'Annulla',
              color: 'negative'
            },
            ok: {
              label: 'Chiama',
              color: 'primary'
            },
            persistent: true
          }).onOk(function () {
            window.open("tel:".concat(_this.parsePhoneNumber(salesAgency.phone)));
          });
        }
      } else {
        // const el = document.getElementById('info-box')
        // const topbar = document.getElementById('topbar')
        // const y = el.getBoundingClientRect().top + window.pageYOffset - topbar.getBoundingClientRect().height - 8
        // window.scrollTo({ top: y, behavior: 'smooth' })
        this.showContactsListDialog = true;
      }
    },
    showFilteredUpdateMeDialog: function showFilteredUpdateMeDialog() {
      this.$root.$emit('showFilteredUpdateMeDialog');
    },
    getMarkerIcon: function getMarkerIcon() {
      var iconName = 'marker-single-';
      if (this.construction.commercial) {
        iconName += 'b';
      }
      if (this.construction.terrain) {
        iconName += 'r';
      }
      if (this.construction.residential) {
        iconName += 'y';
      }
      if (this.construction.status === 'in_history') {
        iconName = 'marker-single-bla';
      }
      return process.env.BASE_URL + '/statics/images/markers/' + iconName + '.png';
    },
    printPage: function printPage() {
      window.print();
    },
    onVerifyRecaptcha: function onVerifyRecaptcha(response) {
      this.recaptchaCode = response;
    },
    onRecaptchaExpired: function onRecaptchaExpired() {
      this.recaptchaVerified = true;
      this.$refs.recaptcha.reset();
    },
    sendIssue: function sendIssue() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.$q.loading.show();
              _context.next = 3;
              return Issue.api().post("/api/constructions/".concat(_this2.construction.id, "/issues"), {
                email: _this2.issueEmail,
                issue_description: _this2.issueText
              }).catch(function () {
                _this2.$q.loading.hide();
              });
            case 3:
              _this2.$q.loading.hide();
              _this2.$q.notify({
                type: 'positive',
                message: _this2.$t('Grazie per la tua segnalazione!')
              });
              _this2.issueEmail = '';
              _this2.issueText = '';
              _this2.showIssueDialog = false;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchData: function fetchData(resolve, reject) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var filters;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              filters = _this3.$q.cookies.get('search_filters');
              _context2.next = 3;
              return Construction.$getByCode(_this3.code, filters, _this3.preview).then(function (res) {
                resolve();
              }).catch(function (e) {
                return reject ? reject(e) : null;
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    addGuestToUpdateList: function addGuestToUpdateList() {
      var _this4 = this;
      this.$q.loading.show();
      Vue.prototype.$axios.post("/api/construction-subscriptions", {
        construction_id: this.construction.id,
        email: this.updateEmail,
        recaptcha: this.recaptchaCode
      }).then(function (response) {
        _this4.$q.loading.hide();
        _this4.$q.notify({
          type: 'positive',
          message: _this4.$t('Iscrizione avvenuta con successo!')
        });
        _this4.updateEmail = '';
        _this4.showUpdateMeDialog = false;
        _this4.agreeToTerms = false;
        _this4.recaptchaCode = '';
      }).catch(function (e) {
        _this4.$q.loading.hide();
      });
    },
    sendEmailToContact: function sendEmailToContact(contact, contactType) {
      this.selectedContactId = contact.id;
      this.contactType = contactType;
      this.showRequestInfoDialog = true;
    },
    sendEmailToAddress: function sendEmailToAddress(address) {
      this.contactEmail = address;
      this.showRequestInfoDialog = true;
    },
    agentsForContact: function agentsForContact(contact) {
      return this.construction.contact_agents.filter(function (c) {
        return c.contact_id === contact.id;
      });
    }
  },
  preFetch: function preFetch(_ref) {
    var currentRoute = _ref.currentRoute,
      previousRoute = _ref.previousRoute,
      redirect = _ref.redirect,
      ssrContext = _ref.ssrContext,
      urlPath = _ref.urlPath,
      publicPath = _ref.publicPath;
    var isReloading = false;
    // Loading.show()
    var cookies = process.env.SERVER ? Cookies.parseSSR(ssrContext) : Cookies; // otherwise we're on client
    var filters = cookies.get('search_filters');
    return Construction.$getByCode(currentRoute.params.webCode, filters, !!currentRoute.query.preview,
    // tell the api server this is a preview, allow unpublished
    !currentRoute.query.preview && !isReloading && !currentRoute.query.prevent_increment,
    // increment_visits (don't increment if preview or reloading)
    !!currentRoute.query.qr_code && !isReloading // increment_qr_clicks (not if reloading)
    ).catch(function (e) {
      if (parseInt(e.response.status) === 404) {
        redirect('/non-trovato');
      }
    });
  },
  mounted: function mounted() {
    this.code = this.$router.currentRoute.params.webCode;
  }
};